import { BaseModel } from './base.model';
import { UnconformityModel } from './unconformity.model';
import { InspectionPlanItemModel } from './inspection-plan-item.model';

export class InspectionPlanModel extends BaseModel {
    name: string;
    description: string;

    unconformities: UnconformityModel[];
    inspection_plan_items: InspectionPlanItemModel[];

    // form only
    weight: number;
    verify?: number;
    keep_status?: number;

    constructor(ipm?: InspectionPlanModel) {
        super();

        this.name = ipm ? ipm.name || null : null;
        this.description = ipm ? ipm.description || null : null;

        this.unconformities = ipm ? ipm.unconformities || null : null;
        this.inspection_plan_items = ipm ? ipm.inspection_plan_items || [] : [];

        this.weight = ipm ? ipm.weight || null : null;
        this.verify = ipm ? ipm.verify || null : null;
        this.keep_status = ipm ? ipm.keep_status || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/inspection-plan.model.ts